import React, { useState, lazy } from 'react';
import { IntegratedLogo } from './IntegratedLogo';
import { MapPin, Clock, Phone, Instagram, Facebook, X, Banknote, Smartphone } from 'lucide-react';
type LegalDoc = 'privacy' | 'terms' | null;
export const Footer = () => {
  const [activeModal, setActiveModal] = useState<LegalDoc>(null);
  return <footer id="contacto" className="bg-beige-50 pt-16 pb-8 border-t border-beige-200" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-139">
          {/* Brand Column */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-140">
            <IntegratedLogo size={200} className="mb-6" data-id="element-141" />
            <p className="font-serif italic text-xl text-gold-600 mb-4" data-id="element-142">
              "La salud de tu cabello empieza con una decisión. ¿Lista para
              transformarlo?"
            </p>
            <div className="flex space-x-4 mt-2" data-id="element-143">
              <a href="https://instagram.com/alisadostefania.becerra" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-beige-200 flex items-center justify-center hover:bg-gold-100 transition-colors" aria-label="Instagram" data-id="element-144">
                <Instagram size={18} className="metallic-gold-icon" data-id="element-145" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100068319984463" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-beige-200 flex items-center justify-center hover:bg-gold-100 transition-colors" aria-label="Facebook" data-id="element-146">
                <Facebook size={18} className="metallic-gold-icon" data-id="element-147" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-start" data-id="element-148">
            <h4 className="font-serif font-medium text-xl text-neutral-900 mb-6" data-id="element-149">
              Contacto
            </h4>
            <ul className="space-y-4 text-neutral-600" data-id="element-150">
              <li className="flex items-start" data-id="element-151">
                <Phone className="w-5 h-5 metallic-gold-icon mr-3 flex-shrink-0 mt-0.5" data-id="element-152" />
                <a href="tel:+13479909488" className="hover:text-gold-600 transition-colors" data-id="element-153">
                  (347) 990-9488
                </a>
              </li>
              <li className="flex items-start" data-id="element-154">
                <MapPin className="w-5 h-5 metallic-gold-icon mr-3 flex-shrink-0 mt-0.5" data-id="element-155" />
                <a href="https://maps.google.com/?q=40-21B+35th+Ave,+Astoria,+NY+11101" target="_blank" rel="noopener noreferrer" className="hover:text-gold-600 transition-colors" data-id="element-156">
                  40-21B 35th Ave, Astoria, NY 11101
                </a>
              </li>
            </ul>

            <div className="mt-8" data-id="element-157">
              <h5 className="font-serif font-medium text-lg text-neutral-900 mb-3 text-center md:text-left" data-id="element-158">
                Formas de pago
              </h5>
              <ul className="space-y-2 text-neutral-600" data-id="element-159">
                <li className="flex items-center" data-id="element-160">
                  <Banknote className="w-5 h-5 metallic-gold-icon mr-3 flex-shrink-0" data-id="element-161" />
                  <span data-id="element-162">Efectivo (Cash)</span>
                </li>
                <li className="flex items-center" data-id="element-163">
                  <Smartphone className="w-5 h-5 metallic-gold-icon mr-3 flex-shrink-0" data-id="element-164" />
                  <span data-id="element-165">Zelle</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Hours */}
          <div className="flex flex-col items-center md:items-start" data-id="element-166">
            <h4 className="font-serif font-medium text-xl text-neutral-900 mb-6" data-id="element-167">
              Horarios
            </h4>
            <ul className="space-y-4 text-neutral-600" data-id="element-168">
              <li className="flex items-start" data-id="element-169">
                <Clock className="w-5 h-5 metallic-gold-icon mr-3 flex-shrink-0 mt-0.5" data-id="element-170" />
                <div data-id="element-171">
                  <p data-id="element-172">Lunes a Sábado: 9:00 AM – 6:00 PM</p>
                  <p className="mt-1" data-id="element-173">Domingos: 10:00 AM – 5:00 PM</p>
                </div>
              </li>
              <li className="mt-4 inline-block bg-beige-200 text-neutral-700 px-3 py-1 rounded text-sm font-medium" data-id="element-174">
                Atención con cita previa
              </li>
            </ul>
          </div>
        </div>

        {/* Google Map */}
        <div className="mb-12 rounded-3xl overflow-hidden border border-beige-200 shadow-md" data-id="element-175">
          <iframe title="Ubicación — 40-21B 35th Ave, Astoria, NY 11101" src="https://www.google.com/maps?q=40-21B%2035th%20Ave,%20Astoria,%20NY%2011101&output=embed" width="100%" height="320" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-176"></iframe>
        </div>

        <div className="border-t border-beige-200 pt-8 text-center text-sm text-neutral-500 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-177">
          <p data-id="element-178">
            © 2026 Alisados Stefania Becerra — Long Island City, Queens, NY
          </p>

          <div className="flex items-center gap-4" data-id="element-179">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-gold-600 transition-colors underline-offset-4 hover:underline" data-id="element-180">
              Política de Privacidad
            </button>
            <span className="text-beige-300" aria-hidden="true" data-id="element-181">
              •
            </span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-gold-600 transition-colors underline-offset-4 hover:underline" data-id="element-182">
              Términos y Condiciones
            </button>
          </div>

          <p className="md:hidden" data-id="element-183">
            Resultados reales. Sin filtros. Sin químicos agresivos.
          </p>
        </div>
      </div>

      {/* Legal Modal */}
      {activeModal && <LegalModal doc={activeModal} onClose={() => setActiveModal(null)} data-id="element-184" />}
    </footer>;
};
type LegalModalProps = {
  doc: 'privacy' | 'terms';
  onClose: () => void;
};
const LegalModal = ({
  doc,
  onClose
}: LegalModalProps) => {
  const isPrivacy = doc === 'privacy';
  const title = isPrivacy ? 'Política de Privacidad' : 'Términos y Condiciones';
  return <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title} data-id="element-185">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-mocha-900/50 backdrop-blur-sm" onClick={onClose} data-id="element-186" />

      {/* Modal panel */}
      <div className="relative bg-beige-50 rounded-3xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col border border-beige-200" data-id="element-187">
        {/* Header */}
        <div className="flex items-start justify-between p-6 md:p-8 border-b border-beige-200" data-id="element-188">
          <div data-id="element-189">
            <h2 className="font-serif text-2xl md:text-3xl text-neutral-900" data-id="element-190">
              {title}
            </h2>
            <p className="text-sm text-gold-600 mt-1" data-id="element-191">
              Última actualización: Junio 2026
            </p>
          </div>
          <button onClick={onClose} className="p-2 -mr-2 -mt-2 text-neutral-500 hover:text-neutral-900 transition-colors" aria-label="Cerrar" data-id="element-192">
            <X size={24} data-id="element-193" />
          </button>
        </div>

        {/* Scrollable content */}
        <div className="p-6 md:p-8 overflow-y-auto text-neutral-700 leading-relaxed space-y-5 text-sm md:text-base" data-id="element-194">
          {isPrivacy ? <PrivacyContent data-id="element-195" /> : <TermsContent data-id="element-196" />}
        </div>
      </div>
    </div>;
};
const PrivacyContent = () => <>
    <p data-id="element-197">
      En <strong data-id="element-198">Alisados Stefania Becerra</strong> respetamos tu privacidad y
      nos comprometemos a proteger la información personal que compartes con
      nosotras. Esta política describe cómo recopilamos, usamos y protegemos tus
      datos.
    </p>
    <div data-id="element-199">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-200">
        1. Información que recopilamos
      </h3>
      <p data-id="element-201">
        Podemos recopilar tu nombre, número de teléfono y correo electrónico
        cuando agendas una cita, nos contactas o te suscribes a nuestras
        comunicaciones. No recopilamos información sensible sin tu
        consentimiento explícito.
      </p>
    </div>
    <div data-id="element-202">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-203">
        2. Uso de la información
      </h3>
      <p data-id="element-204">
        Utilizamos tus datos únicamente para gestionar tus citas, brindarte un
        mejor servicio, responder consultas y, si lo autorizas, enviarte
        promociones y novedades. Nunca venderemos ni compartiremos tu
        información con terceros sin tu permiso.
      </p>
    </div>
    <div data-id="element-205">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-206">
        3. Protección de datos
      </h3>
      <p data-id="element-207">
        Aplicamos medidas razonables de seguridad para proteger tu información
        contra acceso no autorizado, pérdida o uso indebido.
      </p>
    </div>
    <div data-id="element-208">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-209">
        4. Tus derechos
      </h3>
      <p data-id="element-210">
        Puedes solicitar en cualquier momento el acceso, corrección o
        eliminación de tus datos personales escribiéndonos o llamándonos al
        (347) 990-9488.
      </p>
    </div>
    <p className="text-neutral-500 text-sm pt-2" data-id="element-211">
      Si tienes preguntas sobre esta política, contáctanos al (347) 990-9488.
    </p>
  </>;
const TermsContent = () => <>
    <p data-id="element-212">
      Al agendar y recibir nuestros servicios, aceptas los siguientes términos y
      condiciones de <strong data-id="element-213">Alisados Stefania Becerra</strong>.
    </p>
    <div data-id="element-214">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-215">
        1. Citas y reservas
      </h3>
      <p data-id="element-216">
        La atención es exclusivamente con cita previa. Te pedimos llegar
        puntual; las demoras superiores a 15 minutos pueden requerir reagendar
        tu cita según disponibilidad.
      </p>
    </div>
    <div data-id="element-217">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-218">
        2. Cancelaciones
      </h3>
      <p data-id="element-219">
        Si necesitas cancelar o reprogramar, te agradecemos avisar con al menos
        24 horas de anticipación para poder ofrecer ese espacio a otra clienta.
      </p>
    </div>
    <div data-id="element-220">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-221">
        3. Resultados del tratamiento
      </h3>
      <p data-id="element-222">
        Los resultados pueden variar según el tipo, estado e historial de cada
        cabello. Realizamos un diagnóstico previo para recomendar el tratamiento
        más adecuado, pero no garantizamos resultados idénticos para todas las
        clientas.
      </p>
    </div>
    <div data-id="element-223">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-224">
        4. Cuidado posterior
      </h3>
      <p data-id="element-225">
        Para mantener los resultados, es importante seguir las recomendaciones
        de cuidado posterior indicadas por la profesional. El incumplimiento de
        estas puede afectar la duración del tratamiento.
      </p>
    </div>
    <div data-id="element-226">
      <h3 className="font-serif text-lg text-neutral-900 mb-2" data-id="element-227">5. Pagos</h3>
      <p data-id="element-228">
        Los precios y formas de pago se informan antes de cada servicio.
        Cualquier promoción está sujeta a sus condiciones específicas y períodos
        de vigencia.
      </p>
    </div>
    <p className="text-neutral-500 text-sm pt-2" data-id="element-229">
      Para cualquier consulta sobre estos términos, llámanos al (347) 990-9488.
    </p>
  </>;